import {remote} from '../constants/environment';
import {IHistoryDetail} from '../interfaces/dtos';
import {defaultHeaders} from './headers';
import {IHistoryResponse} from '../interfaces/services';
import {customFetch as fetch, remoteCall} from '../utils/services';

export const getHistory = async (token: string): Promise<IHistoryResponse> => {
  const remoteURI = remote.getHistoryUri();
  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'GET',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
      });
    },
    async (response: Response) => {
      if (response.status === 201 || response.status === 200) {
        const data = await response.json();

        if (data.success && data.payload) {
          const success = true;
          const {record} = data.payload;
          return {
            success,
            payload: record as IHistoryDetail[],
          };
        } else {
          return {
            success: false,
            payload: null,
          };
        }
      }
    },
    remoteURI,
  )) as IHistoryResponse;
};
